export const ValidBrandPrefixes = {
  AP: 'AP', // "Afterpay" - Show a Cash App Afterpay header on the flow
  CA: 'CA', // "Cash App" - Show a Cash App logo header on the flow
  NH: 'NH', // "No Header" - Don't show a header on the flow
} as const

export const SESSION_ASSOCIATION_COOKIE_NAME = 'convergence-sess-assoc'
export const SESSION_ASSOCIATION_HEADER_NAME = 'x-convergence-sess-assoc'

export const REDIRECT_QUERY_PARAM = 'redirect'
